import { render, staticRenderFns } from "./TeamSetScores.vue?vue&type=template&id=419eedd2&scoped=true"
import script from "./TeamSetScores.vue?vue&type=script&lang=js"
export * from "./TeamSetScores.vue?vue&type=script&lang=js"
import style0 from "./TeamSetScores.vue?vue&type=style&index=0&id=419eedd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419eedd2",
  null
  
)

export default component.exports